﻿import Valg from '../../../Shared/Scripts/Models/Valg';

export interface ValgState {
    aFamiliesituasjon?: Valg<string>;
    bSivilstatus?: Valg<string>;
    bEnForelder?: Valg<string>;
    cSosken?: Valg<string>;
    visForeldreansvar: boolean;
    visVilkar: boolean;
}

export const UPDATE_VALG = 'UPDATE_VALG';
export const TOGGLE_FORELDREANSVAR = 'TOGGLE_FORELDREANSVAR';
export const TOGGLE_VILKAR = 'TOGGLE_VILKAR';

interface UpdateValgAction {
    type: typeof UPDATE_VALG;
    payload: Partial<ValgState>;
}

export interface ToggleForeldreansvarAction {
    type: typeof TOGGLE_FORELDREANSVAR;
}

export interface ToggleVilkarAction {
    type: typeof TOGGLE_VILKAR;
}

export type ValgStateActionTypes = UpdateValgAction | ToggleForeldreansvarAction | ToggleVilkarAction;
